export * from './mapStrapiMegaMenu';
